import { render, staticRenderFns } from "./AccordionItemDisabled.vue?vue&type=template&id=8aa5fff2&scoped=true"
import script from "./AccordionItemDisabled.vue?vue&type=script&lang=js"
export * from "./AccordionItemDisabled.vue?vue&type=script&lang=js"
import style0 from "./AccordionItemDisabled.vue?vue&type=style&index=0&id=8aa5fff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa5fff2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/AccordionItemDisabled.vue
// module id = 253
// module chunks = 0